// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1FXT5","label":"Completed_label__2ZrnH"};